import { Deck } from './types/AppState';
import { ExodusCard } from './types/ExodusCard';

export const getCardKey = (c: ExodusCard): string => c.card_id;
export const getCardCount = (card: ExodusCard, cardMap: Deck) => cardMap?.get?.(getCardKey(card))?.quantity ?? 0;
